import { useActions } from '@root/core/hooks/useActions';
import useDebounce from '@root/core/hooks/useDebounce';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import SearchTable from '@root/modules/Warehouse/Shared/Table/searchTable';
import { Button, Divider, Menu, MenuProps, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { TableRowSelection } from 'antd/lib/table/interface';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import settlementService from '../../Services/settlementService';

interface labelSelect {
  key: string;
  label: string;
}

interface DataType {
  key: React.Key;
  id: number;
  ReceiptID: string;
  issuingDate: string;
  Customer: string;
  Country: string;
  Amount: string;
  Status: string;
}

const TableBilling = () => {
  const [labelFilter, setLabelFilter] = useState<labelSelect>({
    key: '1',
    label: 'Select'
  });
  const [labelReturn, setLabelReturn] = useState<labelSelect>({
    key: '1',
    label: 'Select'
  });

  const history = useHistory();

  // state
  const [searchBy, setSearchBy] = useState<string>('');
  const [filterDateFrom, setFilterDateFrom] = useState<string>();
  const [filterDateTo, setFilterDateTo] = useState<string>();
  const [filterBy, setFilterBy] = useState<string>();
  const [valueSearch, setValueSearch] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sort, setSort] = useState(true);
  const debounce = useDebounce(valueSearch, 1000);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  // getting list settlement
  const { handleSettlementList } = useActions();

  useEffect(() => {
    handleSettlementList(
      currentPage,
      sort,
      filterDateFrom,
      filterDateTo,
      filterBy,
      searchBy,
      debounce
    );
  }, [sort, filterDateFrom, filterDateTo, filterBy, searchBy, debounce]);

  // Get table biiling inquiry
  const { data } = useTypedSelector((state) => state.settlementReducer);
  const columns: ColumnsType<DataType> = [
    {
      title: 'Receipt ID',
      dataIndex: 'receiptId'
    },
    {
      title: 'Issuing Date',
      dataIndex: 'IssuingDate'
    },
    {
      title: 'Customer ID',
      dataIndex: 'email'
    },
    {
      title: 'Country',
      dataIndex: 'country'
    },
    {
      title: 'Amount',
      dataIndex: 'billingAmount'
    },
    {
      title: 'Status',
      dataIndex: 'billingStatus'
    }
  ];

  const getDate = (startDate: string, endDate: string) => {
    setFilterDateFrom(startDate);
    setFilterDateTo(endDate);
    setCurrentPage(1);
  };

  const getText = (text: string) => {
    setValueSearch(text);
  };

  const getSelectFilter: MenuProps['onClick'] = (e) => {
    setSearchBy(e.key);
    setLabelFilter({ key: e.key, label: e.domEvent.target.innerText });
  };

  const getSelectFilterBy: MenuProps['onClick'] = (e) => {
    setLabelReturn({ key: e.key, label: e.domEvent.target.innerText });
    setFilterBy(e.key);
    setCurrentPage(1);
  };
  const menuFilterBy = [
    {
      id: 1,
      title: 'Select',
      list: (
        <Menu
          onClick={getSelectFilterBy}
          items={[
            { label: 'Request', key: 'Request' },
            {
              label: 'Completed',
              key: 'Completed'
            }
          ]}
        />
      )
    }
  ];

  const menuFilter = [
    {
      id: 1,
      title: 'Select',
      list: (
        <Menu
          onClick={getSelectFilter}
          items={[
            { label: 'Receipt ID', key: 'receiptId' },
            {
              label: 'Customer',
              key: 'email'
            }
          ]}
        />
      )
    }
  ];
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<DataType> = {
    onChange: onSelectChange,
    preserveSelectedRowKeys: true
  };

  // download billing inquiry
  const idMap = selectedRowKeys.map((item: React.Key) => item);

  const arrId = {
    ids: idMap
  };

  const handleDownload = async () => {
    if (selectedRowKeys.length === 0) {
      const resp = await settlementService.postDownloadExcel(
        currentPage,
        sort,
        filterDateFrom,
        filterDateTo,
        filterBy,
        searchBy,
        valueSearch
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Billing_inquiry_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([resp]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await settlementService.postDownloadExelId(arrId);
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Billing_inquiry_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  return (
    <div className="tableBilling">
      <SearchTable
        labelSearchType={labelReturn}
        labelSearchFilter={labelFilter}
        getDate={getDate}
        searchText={getText}
        searchType={menuFilterBy}
        searchFilter={menuFilter}
        isBilling={true}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '15px 17px',
          background: 'white',
          alignItems: 'center'
        }}
      >
        <div>
          <span style={{ marginLeft: 8, marginRight: 8 }}>
            Total Transaction {data?.count}
          </span>
          <Divider type="vertical" />
          <span style={{ marginLeft: 8 }}>
            Selected Transaction {selectedRowKeys.length}
          </span>
        </div>

        <div className="wrapBtnTable">
          <Button className="downExcel" onClick={handleDownload}>
            Download Excel
          </Button>
          <Button
            onClick={() => {
              history.push({
                pathname: `/admin/billingInquiry/create-inquiry`
              });
            }}
            className="createBill"
          >
            Create Billing Inquiry
          </Button>
        </div>
      </div>

      <Table
        className="warehouse-table"
        rowSelection={rowSelection}
        dataSource={data?.rowData}
        columns={columns}
        pagination={{
          total: data.count,
          current: currentPage,
          onChange: (currentPage) => {
            setCurrentPage(currentPage);
            handleSettlementList(
              currentPage,
              sort,
              filterDateFrom,
              filterDateTo,
              filterBy,
              searchBy,
              valueSearch
            );
          }
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              history.push({
                pathname: `/admin/billingInquiry/billingInquiryDetail/${record.key}`
              });
            }
          };
        }}
      />
    </div>
  );
};

export default TableBilling;
